export const GLOBAL_VARIABLE = 'HubSpotConversations';
export const ON_READY_CALLBACKS = 'hsConversationsOnReady';
export const SETTINGS_VARIABLE = 'hsConversationsSettings';
export const ON_EXIT_INTENT = 'ON_EXIT_INTENT';
export const ON_WIDGET_LOAD = 'ON_WIDGET_LOAD';